// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Switch__pc_only___m9Dre","sp_only":"Switch__sp_only___216UK","container":"Switch__container___Iq1D1","item":"Switch__item___121rE","selected":"Switch__selected___28kT_"};